import React from 'react'
import { Main, MainBody, MainTop, MainTopTitle } from '@/components/Layout'
import Resx from '@/components/Resx'
import { localized } from '@/decorators/localized'
import AllReportSubmissionsGrid from '@/components/reporting/allReportSubmissionsGrid'

@localized()
class ForecastAllReportSubmissions extends React.Component {
  render () {
    return (
      <Main>
        <MainTop>
          <MainTopTitle>
            <Resx name='Reporting.ForecastReportSubmissions' />
          </MainTopTitle>
        </MainTop>
        <MainBody>
          <AllReportSubmissionsGrid
            forecasting
            detailUrlFormat='/forecast-report-submission-groups/{0}/report-submissions/{1}' />
        </MainBody>
      </Main>
    )
  }
}

export default ForecastAllReportSubmissions



// WEBPACK FOOTER //
// ./src/internal-app/pages/reportSubmissionGroups/submissions/forecastAllReportSubmissions.js